import { OnInit, Component, Input } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';

@Component({
    selector: 'app-antifraude-socio-pj',
    templateUrl: './antifraude-socio-pj.component.html',
    styleUrls: ['./../cadastral-pj/cadastral-pj.component.css']
})

export class AntifraudeSocioPjComponent implements OnInit {

    @Input() dados:any;

    public txtButtonConsultar:string='Consultar agora';
    public consultando:Boolean=false;
    public naoSolicitou:Boolean=false;
    public naoEncontrouRegistros:Boolean=false;
    public modalRef:BsModalRef;

    constructor(private modalService:BsModalService) {}

    ngOnInit(): void {

        if(this.dados.antifraude_socio === undefined){
            this.naoSolicitou = true;
        } else if(this.dados.antifraude_socio === null) {
            this.naoEncontrouRegistros = true;
        }
    }
}